import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "grid flex flex--wrap mb-24" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grid__item a7-12 f6-6" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " Add scope ")
  ])
], -1 /* HOISTED */)
const _hoisted_4 = { class: "steps-nav steps-nav--scope" }
const _hoisted_5 = { class: "grid flex flex--wrap mb-24" }
const _hoisted_6 = { class: "grid__item a7-12 d6-6" }
const _hoisted_7 = { class: "steps" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($setup.loading)
          ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.steps, (step, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'steps-nav-' + index,
                    class: _normalizeClass(["steps-nav__step", ( step.step_number <= $setup.active_step_number ) ? ' steps-nav__step--active' : null])
                  }, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["steps-nav__step-title", ( step.step_number < $setup.active_step_number ) ? ' steps-nav__step-title--completed' : null])
                    }, " Step " + _toDisplayString(step.step_number), 3 /* TEXT, CLASS */),
                    _createElementVNode("p", null, _toDisplayString(step.title), 1 /* TEXT */)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode($setup["PandaDocComponent"], {
                      step: $setup.steps[0],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"]),
                    _createVNode($setup["ProjectScopeComponent"], {
                      step: $setup.steps[1],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"]),
                    _createVNode($setup["ReviewComponent"], {
                      step: $setup.steps[2],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"])
                  ])
                ])
              ])
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}